module.exports = __webpack_public_path__ + "static/IMG_1529-d8d48d40f2ee0c55dadb8b2c514d3dea.gif";